import script from "./CodeBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeBlock.vue?vue&type=script&setup=true&lang=js"

import "./CodeBlock.vue?vue&type=style&index=0&id=7ff297c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff297c1"]])

export default __exports__